import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EspecieEppoPopupComponent } from '../../../core/components/popup/especies/especieEppoPopup.component';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { Tc, WBotanicaExtendedViewModel } from '../../../core/_infrastructure/types/common';
import { GrupoEspecieFrExService } from './grupoespeciefrex.service';
import { GrupoEspecieFrExViewModel } from './grupoespeciefrex.types';

@Component({
    selector: 'app-grupoespeciefrex-edit',
    templateUrl: './grupoespeciefrex-edit.component.html',
})
export class GrupoEspecieFrExEditComponent extends ComponentBase implements OnInit {
    @ViewChild(EspecieEppoPopupComponent) private especieEppoPopupComponent: EspecieEppoPopupComponent;

    editMode: boolean;
    editTitle = 'Nuevo';
    IdForma = 0;
    IdEppo: number | null = 0;
    habilitarBusquedaEppo = false;
    grupoespeciefrEx: GrupoEspecieFrExViewModel;
    listGrupo: Tc[];
    listForma: Tc[] = [];
    listGruposPaisesFr: Tc[];
    visibilitySpinner = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private grupoEspecieFrExService: GrupoEspecieFrExService,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.grupoespeciefrEx = new GrupoEspecieFrExViewModel();
    }

    ngOnInit() {
        this.globalService.getGrupos().subscribe(res => {
            this.listGrupo = res;
        });
        if (this.grupoEspecieFrExService.currentFilterGrupoEspecieFrEx.IdGrupo) {
            this.globalService.getFormasByGrupo(this.grupoEspecieFrExService.currentFilterGrupoEspecieFrEx.IdGrupo).subscribe(res => {
                this.listForma = res;
            });
        }
        this.globalService.getGrupoPaisesFr().subscribe(res => {
            this.listGruposPaisesFr = res;
        });

        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.grupoEspecieFrExService.getGrupoEspecieFrEx(id).subscribe(result => {
                this.grupoespeciefrEx = result;

                this.globalService.getFormasByGrupo(this.grupoespeciefrEx.IdGrupo!).subscribe(res => {
                    this.listForma = res;
                });

                this.IdForma = this.grupoespeciefrEx.IdForma!;

                this.updateForm();

                this.habilitarBusquedaEppo = this.grupoespeciefrEx.IdForma != null ? true : false;
            });
        }
    }

    createForm(): void {
        this.form = this.fb.group({
            Descripcion: ['', Validators.required],
            IdGrupo: [null, Validators.required],
            IdForma: [null, Validators.required],
            CodigoEppo: [null, Validators.required],
            IdGrupoPaisFr: [null, Validators.required],
            Porcentaje: [null, Validators.compose([Validators.required, Validators.maxLength(3), Validators.max(100)])],
            Activo: [true, Validators.required],
        });
    }

    updateForm(): void {
        this.form.setValue({
            Descripcion: this.grupoespeciefrEx.Descripcion,
            IdGrupo: this.grupoespeciefrEx.IdGrupo,
            IdForma: this.grupoespeciefrEx.IdForma,
            CodigoEppo: this.grupoespeciefrEx.CodigoEppo,
            IdGrupoPaisFr: this.grupoespeciefrEx.IdGrupoPaisFr,
            Porcentaje: this.grupoespeciefrEx.Porcentaje,
            Activo: this.grupoespeciefrEx.Activo,
        });
        this.IdEppo = this.grupoespeciefrEx.IdEppo;
    }

    onAcceptDialogEspecieEppo(especieEppo: WBotanicaExtendedViewModel): void {
        this.form.patchValue({
            CodigoEppo: especieEppo.CodigoEppo,
        });
        this.IdEppo = especieEppo.IdCodigoEppo;
    }

    onSearchCodigoEppo(): void {
        this.especieEppoPopupComponent.showDialog(this.form.controls['IdGrupo'].value, this.IdForma, null, false);
    }

    onSelectGrupo(): void {
        const idGrupo = this.form.value.IdGrupo;
        this.globalService.getFormasByGrupo(idGrupo).subscribe(res => {
            this.listForma = res;
        });

        this.form.patchValue({
            IdForma: null,
        });
    }

    onSelectForma(): void {
        this.IdForma = this.form.value.IdForma;

        if (this.IdForma == null) {
            this.habilitarBusquedaEppo = false;
        } else {
            this.habilitarBusquedaEppo = true;
        }

        this.form.patchValue({
            CodigoEppo: '',
        });
    }

    onSubmit(): void {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        this.visibilitySpinner = true;

        let grupoespeciefrEx = new GrupoEspecieFrExViewModel();

        grupoespeciefrEx.Descripcion = this.form.value.Descripcion;
        grupoespeciefrEx.IdGrupo = this.form.value.IdGrupo;
        grupoespeciefrEx.IdForma = this.form.value.IdForma;
        grupoespeciefrEx.IdEppo = this.IdEppo;
        grupoespeciefrEx.IdGrupoPaisFr = this.form.value.IdGrupoPaisFr;
        grupoespeciefrEx.Porcentaje = this.form.value.Porcentaje;
        grupoespeciefrEx.Activo = this.form.value.Activo;

        grupoespeciefrEx.Id = this.grupoespeciefrEx.Id;

        if (this.editMode) {
            this.grupoEspecieFrExService.editGrupoEspecieFrEx(grupoespeciefrEx).subscribe({
                next: res => {
                    this.addSuccessMessage('Grupo Especie FR modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.grupoEspecieFrExService.createGrupoEspecieFrEx(grupoespeciefrEx).subscribe({
                next: res => {
                    this.addSuccessMessage('Grupo Especie FR añadido correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onBack(): void {
        this.router.navigate(['/mantenimiento/frecuenciareducida/gruposespeciesfrex']);
    }
}
